import React from 'react';
import './toggle.scss';

const Toggle = ({ value, onChange }) => (
    <input
      className='toggle'
      id="toggler"
      type="button"
      onClick={onChange}
      checked={value}
      readOnly
    ></input>

)

export default Toggle;